import dayjs from 'dayjs';
import React from 'react';
import { BaseContent, Dropdown, Icon, Tag, ToolbarButton } from '@fourthwall/components';
import { DesktopIcon, DotsHorizontalIcon, MobileIcon } from '@fourthwall/icons';
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString';
import * as S from './DeviceList.styled';
export const DeviceList = ({ items }) => {
    const deviceTypeIconMap = {
        MOBILE: MobileIcon,
        DESKTOP: DesktopIcon,
    };
    const formatLastActiveTime = (lastActive) => {
        const date = dayjs(new Date(lastActive));
        if (date.isSame(dayjs(), 'day')) {
            return React.createElement(TimezonedDateString, { date: lastActive, format: "[today at] HH:mm A" });
        }
        return React.createElement(TimezonedDateString, { date: lastActive, format: "MMM D [at] HH:mm A" });
    };
    return (React.createElement(S.Container, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
        React.createElement("div", null,
            React.createElement(Icon, { component: deviceTypeIconMap[item.type], height: 20 })),
        React.createElement(S.ItemTextContent, null,
            React.createElement(BaseContent, null,
                item.name,
                ' ',
                item.isActive && (React.createElement(S.ItemStatus, null,
                    React.createElement(Tag, { label: "this device", appearance: "success" })))),
            React.createElement(BaseContent, { appearance: "secondary", size: "small" },
                item.lastActive && React.createElement("div", null,
                    "Last active ",
                    formatLastActiveTime(item.lastActive)),
                React.createElement("div", null,
                    "IP: ",
                    item.address))),
        item.onDelete && (React.createElement("div", null,
            React.createElement(Dropdown, { content: React.createElement(Dropdown.Item, { label: "Delete", onClick: item.onDelete }) },
                React.createElement(ToolbarButton, { icon: DotsHorizontalIcon, size: "small" })))))))));
};
